<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('tasks')"
      :columns="columns"
      :column_search="false"
      resource_url="/task/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create task") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <task-modal ref="task_modal" @success="refresh" />
  <subtask-modal ref="subtask_modal" @success="refresh" />
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date,
  format_date_time,
} from "@/utils";
import TaskModal from "./task_modal/Index.vue";
import SubtaskModal from "../subtask_datatable/Index.vue";

export default {
  name: "TaskDatatable",
  components: { GenericTable, TaskModal, SubtaskModal },
  props: {
    module_settings: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("title"),
          name: "title",
          searchable: true,
          //   width: "25%",
          data: (row) => {
            let desc = row.description || "";
            desc = desc.length > 50 ? desc.substring(0, 50) + "..." : desc;

            /** User */
            let user_name = "";
            if (row.assigned_user) {
              if (row.assigned_user.first_name || row.assigned_user.last_name) {
                user_name = `${row.assigned_user.first_name || ""} ${
                  row.assigned_user.last_name || ""
                }`.trim();
              } else {
                user_name = row.assigned_user.username;
              }
            }

            return `<div class="title is-5">${row.title || ""}</div>
            <div class="subtitle is-6 mb-1">${desc}</div>
            <div class="subtitle is-6">${v.$t(
              "assigned user"
            )}: <strong>${user_name}</strong></div>`;
          },
        },
        {
          title: v.$t("due date"),
          name: "due_date",
          searchable: false,
          //   width: "10%",
          data: (row) => {
            return row.due_date ? format_date(row.due_date) : "";
          },
        },
        {
          title: v.$t("progress"),
          name: "progress",
          searchable: false,
          //   width: "10%",
          data: (row) => {
            let progress = row.completion_percentage || 0;

            /** Status */
            let statusClass = "";
            let statusText = "";
            switch (row.status) {
              case "pending":
                statusClass = "is-warning";
                statusText = v.$t("pending");
                break;
              case "in_progress":
                statusClass = "is-info";
                statusText = v.$t("in progress");
                break;
              case "completed":
                statusClass = "is-success";
                statusText = v.$t("completed");
                break;
              case "cancelled":
                statusClass = "is-danger";
                statusText = v.$t("cancelled");
                break;
              default:
                statusClass = "is-light";
                statusText = row.status || "";
            }

            /** Priority */
            let priorityClass = "";
            let priorityText = "";
            switch (row.priority) {
              case "low":
                priorityClass = "is-success";
                priorityText = v.$t("low");
                break;
              case "medium":
                priorityClass = "is-warning";
                priorityText = v.$t("medium");
                break;
              case "high":
                priorityClass = "is-danger";
                priorityText = v.$t("high");
                break;
              case "critical":
                priorityClass = "is-danger";
                priorityText = v.$t("critical");
                break;
              default:
                priorityClass = "is-light";
                priorityText = row.priority || "";
            }

            return `<div>
                      <progress class="progress is-small is-primary" value="${progress}" max="100">${progress}%</progress>
                      <span class="tag ${statusClass}">${statusText}</span>
                      <span class="tag ${priorityClass}">${priorityText}</span>
                      <span class="is-size-7 has-text-weight-bold">${progress}%</span>
                    </div>`;
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          //   width: "15%",
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.$refs.task_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view subtasks"),
                icon: "fa fa-list",
                icon_class: "is-small has-text-info",
                click: function (e) {
                  v.$refs.subtask_modal.show_subtasks(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete task?"),
                    v,
                    () => {
                      del("/task", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.task_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style scoped></style>
